import styled from "styled-components";

export const Card = styled.div`
  width: 100%;
  max-width: 640px;
  margin: 20px auto 0;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 8px 30px rgb(0 0 0 / 0.08);
  padding: 28px 24px 32px;
  text-align: center;
`;

export const Title = styled.h2`
  font-weight: 800;
  font-size: 28px;
  color: #2a2a2a;
  margin: 0 0 16px;
`;

export const ImageBox = styled.div`
  margin: 8px auto 20px;
  img {
    display: block;
    width: 100%;
    height: auto;
    max-width: 240px;
    margin: 0 auto;
    object-fit: contain;
  }
`;

export const Body = styled.p`
  font-size: 18px;
  line-height: 1.5;
  color: #3a3a3a;
  margin: 0 0 24px;
`;

export const Button = styled.a`
  display: inline-block;
  padding: 14px 32px;
  font-weight: 700;
  letter-spacing: 0.08em;
  color: #ffffff;
  text-decoration: none;
  border-radius: 6px;
  background: linear-gradient(180deg, #e6c463 0%, #b8912f 100%);
  cursor: pointer;
`;
